define('viewmodels/modals/alerts/MessageAlert',[
    'underscore',
    'knockout'
], function (_, ko) {

    function fetch(hash, property, defaultValue) {
        return hash[property] !== undefined ? hash[property] : defaultValue;
    }

    var MessageAlert = function (dialog, vocabulary, title, message, callToActionText, options) {
        this.dialog = dialog;
        this.title = title;
        this.message = message;
        this.callToActionText = (callToActionText || ko.observable()).withFallback(
            vocabulary.translate('BUTTON_CLOSE')
        );

        options = options || {};

        this.titleInHeader = fetch(options, 'titleInHeader', false);
        this.showIcon = fetch(options, 'showIcon', true);
        this.textAlign = fetch(options, 'textAlign', 'center');
        this.headerType = fetch(options, 'headerType', 'alert');
        this.icon = fetch(options, 'icon', 'icons-exclamation-mark');
    };

    MessageAlert.prototype.close = function () {
        this.dialog.close(this);
    };

    return MessageAlert;
});

